import React, { useState } from "react";
import Footer from "./Footer";

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    interest: "",
    updates: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    // prevent default form submission behavior
    if (e && e.preventDefault) e.preventDefault();

    const updatedData = {
      location: "50-sunset",
      data: JSON.stringify({
        "First Name": formData.firstName,
        "Last Name": formData.lastName,
        Email: formData.email,
        Mobile: formData.mobile,
        "What are you interested in?": formData.interest,
        "Get Updates": formData.updates,
      }),
    };

    try {
      const originalString = `hbhotel&& ${new Date().toDateString()}`;
      const encodedString = btoa(originalString);
      const response = await fetch(
        "https://test.metaluxe.com.au/api/v1/feedback_forms",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${encodedString}`,
          },
          body: JSON.stringify({
            feedback_forms: updatedData,
          }),
        }
      );

      // Check for a successful response (status 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // You can process the response body if needed, but the original code just awaited it
      await response.json();

      // reset form on success
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        interest: "",
        updates: false,
      });
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  };

  return (
    <div className="bg-cream">
      <div className="max-w-4xl mx-auto pt-32 px-5">
        <p className="text-center text-2xl	tracking-wider">
          Register now for exclusive early access to designs and pricing.
        </p>
        <h1 className="text-center my-12 text-2xl font-bold">
          REGISTRATION OF INTEREST
        </h1>
        <form onSubmit={handleSubmit} className="pt-4">
          {/* First and Last Name */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-3">
            <div>
              <input
                type="text"
                name="firstName"
                placeholder="First Name *"
                className="w-full border-b border-black bg-transparent focus:outline-none border-b-2 py-2 placeholder-black "
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                name="lastName"
                placeholder="Last Name *"
                className="w-full border-black bg-transparent focus:outline-none border-b-2 py-2 placeholder-black "
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-3">
            <div>
              <input
                type="text"
                name="mobile"
                placeholder="Mobile *"
                className="w-full border-b border-black bg-transparent focus:outline-none border-b-2 py-2 placeholder-black "
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="email"
                name="email"
                placeholder="Email *"
                className="w-full border-b border-black bg-transparent focus:outline-none border-b-2 py-2 placeholder-black "
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* What are you interested in? */}
          <div className="flex justify-center items-center w-full sm:w-[50%] mb-3 m-auto">
            <label htmlFor="interest" className="sr-only">
              What are you interested in? *
            </label>
            <select
              name="interest"
              id="interest"
              className="w-full border-b border-black bg-transparent focus:outline-none border-b-2 py-2 placeholder-black "
              value={formData.interest}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                What are you interested in?{" "}
              </option>
              <option value="1-bedroom residences">
                1 bedroom residences from 50m²
              </option>
              <option value="2-bedroom residences">
                2 bedroom residences from 70m²
              </option>
              <option value="3-bedroom residences">
                3 bedroom residences from 100m²
              </option>
              <option value="The Sky Homes Collection">
                Sky Homes from 125m²
              </option>
              <option value="Commerical Leasing Enquiries">
                Commerical Leasing Enquiries
              </option>
            </select>
          </div>

          {/* Checkbox */}
          <div className="flex items-center text-left w-full sm:w-[55%] md:w-[60%] m-auto text-black mt-16">
            <input
              type="checkbox"
              name="updates"
              className="w-8 h-8 bg-cream"
              checked={formData.updates}
              onChange={handleChange}
              id="agree"
            />
            <label htmlFor="agree" className="ml-3 text-p-xxs">
              By checking this box you agree to receive updates.
            </label>
          </div>

          {/* Privacy Notice */}
          <div className="text-p-xxs  mt-8 mb-20 w-full md:w-[50%] m-auto ">
            By clicking Submit you consent to our{" "}
            <a href="#" className="underline">
              Privacy Policy
            </a>
            .
          </div>

          {/* Submit Button */}
          <div className="w-100 text-center">
            <button
              type="submit"
              className="text-black  mb-56 px-3 text-lg font-semibold border-black border-b-2 pt-4 tracking-wider	"
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
